import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from './designSlice';

export interface HistoryState {
  past: DesignState[];
  future: DesignState[];
  maxHistoryLength: number;
}

const initialState: HistoryState = {
  past: [],
  future: [],
  maxHistoryLength: 30,
};

const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    pushState: (state, action: PayloadAction<DesignState>) => {
      state.past = [...state.past, action.payload].slice(-state.maxHistoryLength);
      state.future = [];
    },
    undo: (state, action: PayloadAction<DesignState>) => {
      const previous = state.past[state.past.length - 1];
      if (previous) {
        state.past = state.past.slice(0, -1);
        state.future = [action.payload, ...state.future];
      }
    },
    redo: (state, action: PayloadAction<DesignState>) => {
      const next = state.future[0];
      if (next) {
        state.past = [...state.past, action.payload];
        state.future = state.future.slice(1);
      }
    },
    clearHistory: (state) => {
      state.past = [];
      state.future = [];
    },
  },
});

export const { pushState, undo, redo, clearHistory } = historySlice.actions;
export default historySlice.reducer;
